import React from 'react';
import RadioInput from '../../components/RadioButton';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { markSuicideAttempt } from '../../core/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../core/app_state_config';
import './suicide-attempt.scss';

const SuicideAttempt: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const form = useSelector((state: RootState) => state.app).suicide_attempt;
    const [response, setResponse] = React.useState<any>(null);

    React.useEffect(() => {
        if (form !== null) {
            setResponse(form ? 'yes' : 'no');
        }
        return;
    }, [form]);

    function onChanged(value: any) {
        setResponse(value);
    }

    function onSubmitted() {
        dispatch(markSuicideAttempt(response === 'yes'));
        if (response === 'yes') {
            navigate('/suicide-attempt-when', { replace: true });
        } else {
            navigate('/result', { replace: true });
        }
    }

    return (
        <div className="suicide-attempt">
            <h1 className="suicide-attempt__title">Have you had any previous experiences with suicide attempts?</h1>
            <h4 className="suicide-attempt__subtitle">It's important for us to understand your journey so we can provide the best care possible.</h4>
            <RadioInput id={'yes'} label={'Yes'} groupValue={response} onChange={onChanged} value={'yes'} />
            <RadioInput id={'no'} label={'No'} groupValue={response} onChange={onChanged} value={'no'} />
            <div style={{ marginTop: 16 }}>
                <Button type='primary' onPressed={onSubmitted} disabled={!response}>
                    {'Continue'}
                </Button>
            </div>
        </div>
    );
}

export default SuicideAttempt;
